import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6464628"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-card" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "profile-card__name" }
const _hoisted_4 = { class: "profile-card__phone" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "profile-card__phone-icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#0668e1",
    d: "M.999 11.839c1.157 0 2.267-.186 3.302-.528a.943.943 0 0 1 .944.222l2.036 2.035a13.934 13.934 0 0 0 6.098-6.088l-2.035-2.044a.905.905 0 0 1-.232-.935c.342-1.036.527-2.146.527-3.303a.93.93 0 0 1 .926-.926h3.238a.93.93 0 0 1 .926.926c0 8.688-7.042 15.73-15.73 15.73a.928.928 0 0 1-.925-.926v-3.238c0-.509.415-.925.925-.925z"
  })
], -1))
const _hoisted_6 = {
  key: 0,
  class: "profile-card__limited"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "profile-card__limited-title" }, "محدودیت خرید:", -1))
const _hoisted_8 = {
  key: 0,
  class: "profile-card__limited-content"
}
const _hoisted_9 = {
  key: 1,
  class: "profile-card__limited-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert = _resolveComponent("alert")!
  const _component_unlimited = _resolveComponent("unlimited")!
  const _component_logout = _resolveComponent("logout")!
  const _component_profile_loading = _resolveComponent("profile-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.error = undefined)),
          variant: "danger",
          title: _ctx.error
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.user)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("img", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputRef && _ctx.inputRef.click())),
            class: "profile-card__avatar",
            src: _ctx.avatar,
            alt: "avatar"
          }, null, 8, _hoisted_2),
          _createElementVNode("input", {
            type: "file",
            class: "d-none",
            ref: "inputRef",
            accept: ".jpeg,.jpg,.png",
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileInputChange && _ctx.onFileInputChange(...args)))
          }, null, 544),
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.user.item.name) + " " + _toDisplayString(_ctx.user.item.lastname), 1),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.formatedMobile), 1)
          ]),
          (
          _ctx.user.item.buy_limit_status === 'limited' ||
          _ctx.user.item.status === 'unverified'
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                (_ctx.user.item.status === 'unverified')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, " حساب فعال نیست! "))
                  : (_ctx.user.item.buy_limit_status === 'limited')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " هر ۲۴ ساعت " + _toDisplayString(_ctx.user.item.buy_limit) + " دلار ", 1))
                    : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock(_component_unlimited, { key: 1 })),
          _createVNode(_component_logout)
        ], 64))
      : (_openBlock(), _createBlock(_component_profile_loading, { key: 2 }))
  ]))
}